import { render } from "./areas-popup.vue?vue&type=template&id=ed477e08"
import script from "./areas-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./areas-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/roles/areas-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ed477e08"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ed477e08', __exports__)) {
    api.reload('ed477e08', __exports__)
  }
  
  module.hot.accept("./areas-popup.vue?vue&type=template&id=ed477e08", () => {
    api.rerender('ed477e08', render)
  })

}


export default __exports__